// GĐ4a SỔ KINH NGHIỆM — phần KHÔNG phụ thuộc gì (so-do.ts dùng được mà không vòng import): bộ lọc chống "đầu độc trí nhớ", chuẩn hoá chữ,
// và cách NỐI bài học vào giong_dieu của knowledge (bot đã đọc knowledge.giong_dieu khi soạn + khi kiểm nội dung — không cần sửa bot).
// docs/thiet-ke-gd4a-so-kinh-nghiem.md mục 3 + 5.

import { loiKyTuDieuKhien } from "./chuoi-an-toan";

export const GIOI_HAN_KN = {
  noiDung: 200, // một bài học
  soCapHoc: 5, // đủ N cặp (câu AI → câu chủ Boss sửa) chưa xét thì rút bài học
  xacNhan: 3, // củng cố đủ N lần → tự thành "xác nhận"
  bundleBai: 8, bundleKyTu: 1200, // ảnh chụp vào knowledge của bản chạy được
  promptBai: 15, promptKyTu: 2000, // khối đưa vào prompt AI máy chủ
  mucSoDo: 220, tongSoDo: 1500, // kiểm SoDo.kinhNghiem (mục có thể mang dấu "(đang thử) ")
  aiBai: 3, aiCap: 20, // AI rút tối đa 3 bài từ tối đa 20 cặp một lần
  bangChung: 20,
} as const;

export const DAU_DANG_THU = "(đang thử) ";

const dem = (s: string) => Array.from(s).length;
export const motDong = (s: string): string => s.replace(/\s+/g, " ").trim();

/** Chữ thường, bỏ dấu tiếng Việt (đ → d) — để so khớp "mật khẩu" lẫn "mat khau". */
export function boDau(s: string): string {
  return s.normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D").toLowerCase();
}

/** Khoá so sánh nội dung: bỏ dấu, bỏ dấu câu/emoji, gộp khoảng trắng. */
export function khoaNoiDung(s: string): string {
  return boDau(s).replace(/[^\p{L}\p{N}\s]/gu, " ").replace(/\s+/g, " ").trim().slice(0, 200);
}

const DIEU_KHIEN = /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/;
export const LIEN_KET = /https?:\/\/|www\.|\b[a-z0-9-]+\.(com|vn|net|org|io|me|xyz|info|biz|co|app|link|ly|gl)\b/i;
const SDT = /(?:^|[^0-9])(?:\+?84|0)[\s.-]?[0-9][0-9 .-]{7,11}[0-9](?:[^0-9]|$)/;
const EMAIL = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
const HTML_NGUY_HIEM = /<\s*\/?\s*(script|iframe|object|embed|style|img|svg|form)\b|javascript:|on(error|load|click)\s*=/i;
// So khớp trên chữ ĐÃ BỎ DẤU (boDau) → một mẫu bắt cả có dấu lẫn không dấu.
const DANG_NHAP = /\b(mat khau|password|passwd|dang nhap|login|log in|sign in|otp|ma xac (minh|thuc|nhan)|ma 2 lop|2fa|token|api ?key|cookie|secret|tai khoan ngan hang|so the|cvv)\b/;
// Lệnh vượt rào / tiêm lệnh — viết CÓ DẤU, so trên chữ thường có dấu. Bản bỏ dấu của mẫu cũng được so trên chữ đã bỏ dấu khi mẫu vẫn MỘT NGHĨA
// sau khi bỏ dấu ("bỏ qua quy tắc"); mẫu hai nghĩa ("bỏ" ≈ "bộ", "tắt" ≈ "tất", "xoá" ≈ "xoa", "tăng" ≈ "tầng") chỉ so bản bỏ dấu khi người gõ
// KHÔNG dấu hoàn toàn (tránh chặn oan "bị bộ kiểm nội dung loại").
const LENH_NGUY_HIEM: { re: RegExp; motNghia: boolean; reKhongDau: RegExp }[] = [
  { re: /(bỏ qua|phớt lờ|lờ đi|quên hết|quên đi|quên mọi).{0,20}(quy tắc|hướng dẫn|chỉ dẫn|lệnh|ràng buộc|điều cấm)/, motNghia: true },
  { re: /\bignore\b.{0,20}\b(previous|above|all|prior|instructions?|rules?)\b/, motNghia: true },
  { re: /(system prompt|developer mode|jailbreak|prompt injection)/, motNghia: true },
  { re: /(không cần|vô hiệu)\s.{0,12}(duyệt|kiểm tra|kiểm nội dung)/, motNghia: true },
  { re: /(^|\s)(bỏ|tắt|gỡ)\s.{0,12}(duyệt|kiểm tra|kiểm nội dung)/, motNghia: false },
  { re: /(^|\s)tự (động )?duyệt/, motNghia: true },
  { re: /(^|\s)(tăng|nâng|bỏ)\s.{0,10}(hạn mức|giới hạn|số bài|số lượng)/, motNghia: false },
  { re: /(^|\s)(xoá|xóa)\s.{0,12}(hết|tất cả|dữ liệu|tài khoản|kịch bản|bài học)/, motNghia: false },
  { re: /(chuyển|gửi|nạp|rút)\s.{0,6}(tiền|khoản)/, motNghia: true },
  { re: /rm -rf|\beval\s*\(|\bexec\s*\(/, motNghia: true },
].map((x) => ({ ...x, reKhongDau: new RegExp(boDau(x.re.source)) }));
export function laLenhNguyHiem(s: string): boolean {
  const coDau = s.normalize("NFC").toLowerCase();
  const khongDau = boDau(s);
  const goKhongDau = coDau === khongDau; // người gõ không dấu hoàn toàn
  return LENH_NGUY_HIEM.some((x) => x.re.test(coDau) || ((x.motNghia || goKhongDau) && x.reKhongDau.test(khongDau)));
}

/** Kiểm MỘT bài học (mọi nguồn: chủ Boss gõ, AI rút, luật tất định, nhập tệp). null = hợp lệ; chuỗi = lý do từ chối (tiếng Việt). */
export function kiemBaiHoc(v: unknown): string | null {
  if (typeof v !== "string") return "Bài học phải là chữ";
  const s = motDong(v);
  if (!s) return "Bài học không được để trống";
  if (dem(s) > GIOI_HAN_KN.noiDung) return `Bài học quá dài (${dem(s)}/${GIOI_HAN_KN.noiDung} ký tự) — viết ngắn, một ý`;
  if (DIEU_KHIEN.test(v)) return loiKyTuDieuKhien("Bài học", v);
  if (s.includes("{{") || s.includes("}}")) return "Bài học không được chứa “{{” hoặc “}}”";
  if (HTML_NGUY_HIEM.test(s)) return "Bài học không được chứa mã HTML/JavaScript";
  if (LIEN_KET.test(s)) return "Bài học không được chứa liên kết hay tên miền — AI không được dẫn người đọc đi đâu";
  if (EMAIL.test(s)) return "Bài học không được chứa địa chỉ email";
  if (SDT.test(s)) return "Bài học không được chứa số điện thoại";
  const k = boDau(s);
  if (DANG_NHAP.test(k)) return "Bài học không được nói tới đăng nhập, mật khẩu, mã xác minh hay khoá bí mật — máy không bao giờ làm việc đó";
  if (laLenhNguyHiem(s)) return "Bài học giống một lệnh vượt rào an toàn (bỏ quy tắc, bỏ duyệt, tăng giới hạn, xoá, chuyển tiền…) — không nhận";
  return null;
}

// ---- nối bài học vào giọng điệu (knowledge.giong_dieu) — TẤT ĐỊNH, dịch ngược được ----
const DAU_KINH_NGHIEM = "Kinh nghiệm của chủ tài khoản (hãy làm theo): ";
const NOI = " | ";
function duoiKinhNghiem(kn: string[]): string {
  return DAU_KINH_NGHIEM + kn.map((x, i) => `(${i + 1}) ${x}`).join("; ");
}
export function noiGiongDieu(giongDieu: string | undefined, kn: string[] | undefined): string | undefined {
  if (!kn?.length) return giongDieu;
  const duoi = duoiKinhNghiem(kn);
  return giongDieu ? `${giongDieu}${NOI}${duoi}` : duoi;
}
/** Ngược của noiGiongDieu: bỏ đúng phần đã nối (không khớp → trả nguyên). */
export function tachGiongDieu(giongDieu: unknown, kn: string[] | undefined): unknown {
  if (typeof giongDieu !== "string" || !kn?.length) return giongDieu;
  const duoi = duoiKinhNghiem(kn);
  if (giongDieu === duoi) return "";
  if (giongDieu.endsWith(NOI + duoi)) return giongDieu.slice(0, giongDieu.length - NOI.length - duoi.length);
  return giongDieu;
}

/** L-86: giọng điệu đưa cho BỘ KIỂM NỘI DUNG — bỏ các bài học "(đang thử)" (chưa xác nhận, không phải điều cấm). Giữ phần người dùng viết + bài đã xác nhận. */
export function boBaiDangThu(giongDieu: string): string {
  if (!giongDieu) return giongDieu;
  const i = giongDieu.indexOf(DAU_KINH_NGHIEM);
  if (i < 0) return giongDieu;
  const truoc = giongDieu.slice(0, i), duoi = giongDieu.slice(i + DAU_KINH_NGHIEM.length);
  const muc = duoi.split(/; (?=\(\d+\) )/).filter((m) => !/^\(\d+\) \(đang thử\) /.test(m));
  if (!muc.length) return truoc.endsWith(NOI) ? truoc.slice(0, -NOI.length) : truoc;
  return `${truoc}${DAU_KINH_NGHIEM}${muc.join("; ")}`;
}

/** Chuẩn hoá + kiểm SoDo.kinhNghiem (ảnh chụp bài học trong sơ đồ). */
export function chuanHoaKinhNghiemSoDo(v: unknown): { kn: string[]; loi: string[] } {
  if (v === undefined || v === null) return { kn: [], loi: [] };
  if (!Array.isArray(v) || v.some((x) => typeof x !== "string")) return { kn: [], loi: ["Kinh nghiệm của kịch bản phải là danh sách chữ"] };
  const loi: string[] = [];
  const kn = [...new Set((v as string[]).map(motDong).filter(Boolean))];
  if (kn.length > GIOI_HAN_KN.bundleBai) loi.push(`Kinh nghiệm của kịch bản tối đa ${GIOI_HAN_KN.bundleBai} bài`);
  let tong = 0;
  kn.forEach((x, i) => {
    tong += dem(x);
    if (dem(x) > GIOI_HAN_KN.mucSoDo) { loi.push(`Kinh nghiệm ${i + 1} quá dài (tối đa ${GIOI_HAN_KN.mucSoDo} ký tự)`); return; }
    const l = kiemBaiHoc(x.startsWith(DAU_DANG_THU) ? x.slice(DAU_DANG_THU.length) : x);
    if (l) loi.push(`Kinh nghiệm ${i + 1}: ${l}`);
  });
  if (tong > GIOI_HAN_KN.tongSoDo) loi.push(`Kinh nghiệm của kịch bản quá dài (tổng ${tong}/${GIOI_HAN_KN.tongSoDo} ký tự)`);
  return { kn, loi };
}
